module.exports = __webpack_public_path__ + "static/media/izbirati-izbrati.e83c2405.png";